export default __webpack_public_path__ + "static/media/correct10.5fdf81ec.mp3";